export function formatVoucherNumber (str: string): string {
    return str.substr(0, 3) + " " + str.substr(3, 3) + " " +
        str.substr(6, 3) + " " + str.substr(9, 3);
}